import { useQuery } from "@tanstack/react-query";
import { scheduleKeys } from "./queryKeys";
import { fetchCompanyProfiles } from "@/services/schedule/shiftService";

export const useCompanyProfiles = (companyId: string | undefined) => {
  return useQuery({
    queryKey: scheduleKeys.companyProfiles(companyId || ''),
    queryFn: async () => {
      if (!companyId) throw new Error('Company ID required');
      const data = await fetchCompanyProfiles();
      
      // CRITICAL: Maintain exact same sorting
      return data.sort((a, b) => (a.first_name || '').localeCompare(b.first_name || ''));
    },
    enabled: !!companyId,
    staleTime: 10 * 60 * 1000, // 10 minutes (profiles change less frequently)
    gcTime: 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus: false, // Profiles don't change often
    refetchOnReconnect: true,
  });
};
